import React from 'react'
import { Link } from 'gatsby'
import { useStore } from '../../lib/context'

import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import css from 'styled-jsx/css'
import { Logo, NavLink, MobileExitArticleButton } from './'

const { className, styles } = css.resolve`
	div {
		height: var(--nav-bar-height);
		min-height: var(--nav-bar-height);
		width: 100%;
		padding: 0 1.25rem;
		display: flex;
		justify-content: space-between;
		z-index: 100;
		grid-column: span 12;
	}
	@media only screen and (min-width: 768px), (pointer: coarse) {
		div {
			transform: none !important;
		}
	}
	@media only screen and (max-width: 768px), (pointer: coarse) {
		div {
			height: var(--nav-bar-height-mobile);
			transform: translateY(0);
			padding: 0 1.25rem;
			padding-right: 10px;
			border-bottom: 1px solid var(--color--gray);
			position: fixed !important;
		}
	}
`

const CommunityButton = () => {
	return (
		<div>
			<Link to={'/community/'}>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150.3 150.3">
					<g id="Layer_2" data-name="Layer 2">
						<g id="Arrow">
							<g id="Ellipse_1" data-name="Ellipse 1">
								<path d="M75.15,4A71.15,71.15,0,1,1,4,75.15,71.23,71.23,0,0,1,75.15,4m0-4A75.15,75.15,0,1,0,150.3,75.15,75.16,75.16,0,0,0,75.15,0Z" />
							</g>
							<circle cx="111.83" cy="75.15" r="7" />
							<circle cx="38.47" cy="75.15" r="7" />
							<circle cx="75.15" cy="75.15" r="7" />
						</g>
					</g>
				</svg>
			</Link>
			<style jsx>{`
				svg {
					height: 40px;
					width: 40px;
				}
				div {
					height: 40px;
					width: 40px;
				}
			`}</style>
		</div>
	)
}

const DesktopNavBar = observer(
	({
		animated,
		noPadding,
		hideOnScroll,
		route,
		wholeLogoMobile,
		hasExitButton,
	}) => {
		const links = [
			{ label: 'Business', link: '/business/' },
			{ label: 'Being', link: '/being/' },
		]
		const {
			uiStore: { navBar__color, hideMobileNavBar },
		} = useStore()

		const transition = {
			opacity: { duration: 0.4 },
			translateY: { duration: 0.4 },
		}

		const navBarUp = hideOnScroll && hideMobileNavBar

		return (
			<>
				<motion.div
					style={{
						backgroundColor: navBar__color,
						position: route === '/community' ? 'relative' : 'fixed',
					}}
					transition={transition}
					animate={{
						y: navBarUp ? -(12 * 8) : 0,
					}}
					className={className}
				>
					<Logo
						animated={animated}
						noPadding={noPadding}
						route={route}
						wholeLogoMobile={wholeLogoMobile}
					/>

					<div className="nav-links">
						{links.map((l) => (
							<NavLink animated={animated} key={l.label} {...l} />
						))}
					</div>
					{hasExitButton && <MobileExitArticleButton />}

					<div className="community">
						<NavLink
							animated={animated}
							noPadding
							link={'/community/'}
							label="Community"
						/>
					</div>
					<div className="community-mobile">
						<CommunityButton />
					</div>

					<style jsx>{`
						.close {
							display: none;
						}
						.community-mobile {
							display: none;
						}
						.community {
							height: 100%;
							display: block;
						}
						.nav-links {
							display: flex;
							flex-direction: row;
						}

						@media only screen and (max-width: 768px), (pointer: coarse) {
							.close {
								height: 100%;
								display: flex;
								align-items: center;
								width: 50px;
							}
							.nav-links {
								display: none;
							}
							.nav-link {
								padding: 0 1.5rem;
							}
							.community-link {
								display: none;
							}
							.community-mobile {
								height: 100%;

								align-items: center;
								display: ${hasExitButton ? 'none' : 'flex'};
							}
							.community {
								display: none;
							}
						}
					`}</style>
					{styles}
				</motion.div>
			</>
		)
	}
)

DesktopNavBar.defaultProps = {
	position: 'fixed',
	backgroundColor: 'transparent',
	color: 'var(--color-black)',
}

export default DesktopNavBar
